import {createFetchableSlice} from '../../utils/createFetchableSlice';
import {fetchBimDetails} from '../../Api';

export const bimDetailsSlice = createFetchableSlice({
    name: 'bimDetails',
    fetchable: fetchBimDetails
});

export default bimDetailsSlice.reducer;